import React, { useState } from 'react';
import { unstable_registerNextDomDrop } from 'polotno/config';

const DraggableImage = ({ src, index, store, isTemplateMode = false }) => {
    const [isDragging, setIsDragging] = useState(false);

    const handleDragStart = () => {
        setIsDragging(true);
        unstable_registerNextDomDrop((pos, element) => {
            // Check if dropped on an existing image element
            if (element && element.type === 'image') {
                element.set({
                    src: src,
                    ...(isTemplateMode && {
                        custom: {
                            ...element.custom,
                            isVariable: true,
                            variableName: 'image',
                            variableType: 'image',
                            imageIndex: index
                        }
                    })
                });
                return;
            }

            // Create new image element if not dropped on existing one
            // We need to preload image to get dimensions or just use default
            const img = new Image();
            img.onload = () => {
                const aspectRatio = img.width / img.height;
                const width = 200;
                const height = width / aspectRatio;

                store.activePage.addElement({
                    type: 'image',
                    src: src,
                    width: width,
                    height: height,
                    x: pos.x,
                    y: pos.y,
                    ...(isTemplateMode && {
                        custom: {
                            isVariable: true,
                            variableName: 'image',
                            variableType: 'image',
                            imageIndex: index
                        }
                    })
                });
            };
            img.src = src;
        });
    };

    const handleDragEnd = () => {
        setIsDragging(false);
        unstable_registerNextDomDrop(null);
    };

    return (
        <div
            draggable={true}
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
            className={`relative aspect-square rounded-md overflow-hidden cursor-move border bg-gray-100 transition-all ${
                isDragging ? 'border-[#8E0DFF] shadow-lg scale-95' : 'border-transparent hover:border-gray-300'
            } ${isTemplateMode ? 'border-dashed border-gray-300' : ''}`}
        >
            <img 
                src={src} 
                alt={`Product view ${index + 1}`}
                className="w-full h-full object-cover pointer-events-none"
            />
            {isTemplateMode && (
                <div className="absolute inset-0 flex items-center justify-center bg-black/10 opacity-0 hover:opacity-100 transition-opacity">
                    <span className="bg-black/50 text-white text-[10px] px-1.5 py-0.5 rounded">
                        Image {index + 1}
                    </span>
                </div>
            )}
        </div>
    );
};

export default DraggableImage;
